import { render } from "./InvitePublicationUserForm.vue.js?vue&type=template&id=39bfaf9e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitePublicationUserForm.vue?vue&type=template&id=39bfaf9e"
import script from "./InvitePublicationUserForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitePublicationUserForm.vue?vue&type=script&lang=js"
export * from "./InvitePublicationUserForm.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitePublicationUserForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/components/publication/InvitePublicationUserForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "39bfaf9e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('39bfaf9e', __exports__)) {
    api.reload('39bfaf9e', __exports__)
  }
  
  module.hot.accept("./InvitePublicationUserForm.vue.js?vue&type=template&id=39bfaf9e!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./InvitePublicationUserForm.vue?vue&type=template&id=39bfaf9e", () => {
    api.rerender('39bfaf9e', render)
  })

}


export default __exports__